import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";
import { isTankmatch } from "components/utils/Permission";

export const CommissionSchema: RegistryItem = {
	[AgreementTypeEnum.Commission]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.PercentageOnAgreements,
			},
		},
		agreementFields: {
			"agreement.conditions": { rules: { hidden: true } },
			"agreement.description": {
				rules: {
					hiddenIf: () => isTankmatch(),
				},
			},
			"agreement.costType": {
				rules: {
					hiddenIf: () => isTankmatch(),
				},
			},
		},
	},
};
